import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { NotificationService } from '@shared/services/notification.service';
import { PersonService } from '../services/person.service';

const COMMUNITY_LEVEL_ID = 5;

export const canCreatePersonInAuthorizedCommunity: CanActivateFn = () => {
  const personService = inject(PersonService);
  const notifications = inject(NotificationService);

  return personService.getAuthorizedUnits().pipe(
    map(units => {
      const hasAuthorizedCommunity = units.some(unit => unit.levelId === COMMUNITY_LEVEL_ID);
      if (hasAuthorizedCommunity) {
        return true;
      }

      notifications.warning('No tienes autorización para crear miembros');
      return false;
    }),
    catchError(() => {
      notifications.error('No se pudieron verificar las comunidades autorizadas');
      return of(false);
    }),
  );
};
